import { Component, OnInit } from '@angular/core';
import { GradoService } from '../services/grado.service';
import {ActivatedRoute, Router} from '@angular/router';


@Component({
  selector: 'app-all',
  templateUrl: './all.component.html',
  styleUrls: ['./all.component.scss']
})
export class AllComponent implements OnInit {
  children: any;

  constructor(private gradoService: GradoService,
              private router: Router,
              private activatedRoute: ActivatedRoute
  ) {

  }

  ngOnInit() {

    this.activatedRoute.params.subscribe( params => {

      this.gradoService.getAll().subscribe(
        (children) => {
          this.children = children;
        }
      );

    });


  }



}
